import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { ProfileService } from '../profile/profile.service';

@Injectable({
  providedIn: 'root'
})
export class PublicGuardService {

  constructor(
    private _profile: ProfileService
  ) { }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    if (next.data && next.data.checkLogin && this._profile.getToken()) {
      return false;
    }
    document.body.classList.add('is-public');

    const hour = new Date().getHours();
    let back = '';

    if(hour > 6 && hour < 13)back = 'morning';
    else if (hour > 12 && hour < 20) back = 'day';
    else back = 'night';

    document.body.classList.add('bg-' + back);

    return true;
  }
}

